/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_Forbiddentitle1Inputs */

const zh_learn_forbiddentitle1 = /** @type {(inputs: Learn_Forbiddentitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你没有访问权限`)
};

const en_learn_forbiddentitle1 = /** @type {(inputs: Learn_Forbiddentitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have access`)
};

const es_learn_forbiddentitle1 = /** @type {(inputs: Learn_Forbiddentitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes acceso`)
};

/**
* | output |
* | --- |
* | "You do not have access" |
*
* @param {Learn_Forbiddentitle1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const learn_forbiddentitle1 = /** @type {((inputs?: Learn_Forbiddentitle1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_Forbiddentitle1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_learn_forbiddentitle1(inputs)
	if (locale === "en") return en_learn_forbiddentitle1(inputs)
	return es_learn_forbiddentitle1(inputs)
});
export { learn_forbiddentitle1 as "learn_forbiddenTitle" }